import React from 'react';
import { Currency } from '@profitfy/pakkun-icons';
import { useTheme } from 'styled-components/macro';

import * as S from './styles';

const Header: React.FC = () => {
  const theme: any = useTheme();

  return (
    <S.HeaderWrapper>
      <Currency size={36} color={theme.colors.green.primary} />
      <S.Heading>Incluir valor adicional</S.Heading>
    </S.HeaderWrapper>
  );
};

export default Header;
